import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from 'Modules/contacard/moduleBreadcrumbs';

export default [
  ...buildCrudRoutes({
    baseName: 'groupLimits',
    basePath: 'group-limits',
    baseBreadcrumbs: [
      ...moduleBreadcrumbs,
    ],
    subModuleActive: 'limits',
    moduleActive: 'contacard',
    moduleGroupName: 'limits',
    card: {
      title: 'Limites de recargas',
      icon: 'microsoft-xbox-controller-battery-low',
    },
    listRoute: {
      pageContent: () => import('Modules/contacard/limits/groupLimits/GroupLimitsCrudList.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      searchOptions: { label: 'Buscar limite', searchAttribute: 'search' },
      pageTitle: 'Listagem de limites',
      navigateBackRoute: 'contacard.submodules.list',
      btnText: 'Adicionar limite',
      newRouteName: 'groupLimits.new',
    },
    newRoute: {
      component: () => import('Modules/contacard/limits/groupLimits/GroupLimitsForm.vue'),
      breadcrumbs: [
        {
          text: 'Criar limite de recarga',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('Modules/contacard/limits/groupLimits/GroupLimitsForm.vue'),
      breadcrumbs: [
        {
          text: 'Editar limite de recarga',
          disabled: true,
        },
      ],
    },
  }),
];
